import { forwardRef, type Ref, type SVGProps } from "react";
const IconUserGroupFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M12 6a6 6 0 0 0-6 6.06v1.23a8.34 8.34 0 0 0 2.54 5.79l-1.71.37c-4 1-4.83 3-4.83 5.41V28a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-3.14c0-2.39-.79-4.45-4.83-5.41l-1.77-.34a8.4 8.4 0 0 0 2.6-5.82v-1.23A6 6 0 0 0 12 6" />
    <path d="m25.17 18-1.77-.35a8.88 8.88 0 0 0 2.6-6v-1.23A6.46 6.46 0 0 0 19.5 4a6.53 6.53 0 0 0-3.56 1A8.07 8.07 0 0 1 20 12v1.23a10 10 0 0 1-1.18 4.55C22.3 19 24 21.31 24 24.86V28a3.9 3.9 0 0 1-.56 2H28a2.15 2.15 0 0 0 2-2v-4.34c0-2.48-.79-4.66-4.83-5.66" />
  </svg>
);
const ForwardRef = forwardRef(IconUserGroupFilledSVG);
ForwardRef.displayName = "IconUserGroupFilled";
export { ForwardRef as IconUserGroupFilled };
